import React, { useState, useEffect, useRef } from 'react';
import './App.css';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCreditCard, faMobileAlt, faUniversity, faBitcoin } from '@fortawesome/free-solid-svg-icons';

// Import des icônes
import { 
  FiMenu, FiX, FiPlay, FiUsers, FiMusic, FiGlobe, 
  FiCheckCircle, FiInstagram, FiTwitter, FiLinkedin, 
  FiMail, FiChevronRight, FiChevronDown, FiHeadphones,
  FiTrendingUp, FiDollarSign, FiGlobe as FiWorld,
  FiBarChart2, FiClock, FiShield, FiAward,
  FiMessageSquare, FiPhone, FiMapPin, FiSend,
  FiStar, FiUser, FiCalendar, FiDownload,
  FiVolume2, FiShare2, FiHeart, FiExternalLink
} from 'react-icons/fi';

import { 
  FaSpotify, FaApple, FaDeezer, FaYoutube, 
  FaTiktok, FaSoundcloud, FaAmazon, FaFacebookF,
  FaTwitch, FaSnapchat, FaPinterest, FaWhatsapp,
  FaCrown, FaFire, FaRocket, FaChartLine,
  FaRegCheckCircle, FaRegStar, FaRegPlayCircle,
  FaArrowRight, FaPlayCircle, FaPauseCircle
} from 'react-icons/fa';

import { 
  MdOutlineWorkspacePremium, MdOutlineVerified,
  MdOutlineAttachMoney, MdOutlineTrendingUp,
  MdOutlineGroup, MdOutlineSchedule, MdOutlineEmail,
  MdOutlinePhone, MdOutlineLocationOn
} from 'react-icons/md';

const App = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState('all');
  const [isScrolled, setIsScrolled] = useState(false);
  const [contactData, setContactData] = useState({
    name: '',
    email: '',
    phone: '',
    artistName: '',
    genre: '',
    message: ''
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [stats, setStats] = useState({
    artists: 0,
    streams: 0,
    countries: 0,
    revenue: 0
  });
  const [isPlaying, setIsPlaying] = useState(false);
  
  const audioRef = useRef(null);

  // Fonctions de gestion des clics
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const handleContactClick = () => {
    scrollToSection('contact');
  };

  const handleAuditClick = () => {
    alert('🎵 Votre audit gratuit a été demandé ! Notre équipe vous contactera dans les 24h.');
    scrollToSection('contact');
  };

  const handleDemoClick = () => {
    alert('🎬 Lancement de la démo vidéo...');
    // Ici vous intégreriez votre vidéo de démo
  };

  const handlePlatformClick = (platformName) => {
    alert(`🎧 Redirection vers ${platformName}...`);
    // Ici vous intégreriez les liens vers vos pages de partenaires
  };

  const handleArtistClick = (artistName) => {
    alert(`🎤 Écoute de ${artistName}...`);
    // Ici vous intégreriez les liens vers les artistes
  };

  const handleSocialClick = (platform) => {
    alert(`📱 Ouverture de ${platform}...`);
    // Ici vous intégreriez les liens sociaux
  };

  const handlePlayMusic = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  // Animations de compteur
  useEffect(() => {
    const counters = [
      { target: 28, duration: 2000, setter: (val) => setStats(prev => ({ ...prev, artists: val })) },
      { target: 56, duration: 2500, setter: (val) => setStats(prev => ({ ...prev, streams: val })) },
      { target: 100, duration: 1500, setter: (val) => setStats(prev => ({ ...prev, countries: val })) },
      { target: 4.2, duration: 3000, setter: (val) => setStats(prev => ({ ...prev, revenue: val.toFixed(1) })) }
    ];

    counters.forEach(({ target, duration, setter }) => {
      let start = 0;
      const increment = target / (duration / 16);
      const timer = setInterval(() => {
        start += increment;
        if (start >= target) {
          setter(target);
          clearInterval(timer);
        } else {
          setter(target === 4.2 ? parseFloat(start.toFixed(1)) : Math.floor(start));
        }
      }, 16);
    });

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Données des CEO
  const ceos = [
    {
      id: 1,
      name: "SILF",
      role: "CEO & Co-Fondateur",
      bio: "Expert en stratégie digitale avec 15 ans d'expérience dans l'industrie musicale. A travaillé avec plus de 200 artistes internationaux.",
      image:  "../images/silf.jpeg",
      social: { linkedin: "#", twitter: "#", instagram: "#" },
      email: "alexandre@streamdistrib.pro"
    },
    {
      id: 2,
      name: "LeMaximal",
      role: "CEO & Co-Fondateur",
      bio: "Spécialiste en marketing digital et relations publiques. Ancienne directeur marketing chez un grand label indépendant.",
      image: "../images/moi.jpeg",
      stats: "+15 ans d'expérience",
      social: { linkedin: "#", twitter: "#", instagram: "#" },
      email: "sophie@streamdistrib.pro"
    },
    {
      id: 3,
      name: "Anis45",
      role: "CEO & Co-Fondateur",
      bio: "Producteur musical et expert en droits d'auteur. A produit plusieurs albums certifiés platine.",
      image: "../images/anis.jpeg",
      stats: "Albums Platine",
      social: { linkedin: "#", twitter: "#", instagram: "#" },
      email: "camille@streamdistrib.pro"
    }
  ];

  // Données des artistes
  const artists = [
    {
      id: 1,
      name: "FIRECH",
      genre: "Pop",
      streams: "45M+",
      platform: "Spotify",
       image: "../images/firech.jpeg",
      status: "rising",
      growth: "+320%",
      social: { instagram: "1.2M", tiktok: "850K" },
      spotifyUrl: "#",
      appleMusicUrl: "#"
    },
    {
      id: 2,
      name: "BIG BEN",
      genre: "Rap Moba",
      streams: "22M+",
      platform: "Apple Music",
      image: "../images/bigben.jpeg",
      status: "established",
      growth: "+45%",
      social: { instagram: "890K", youtube: "450K" },
      spotifyUrl: "#",
      appleMusicUrl: "#"
    },
    {
      id: 3,
      name: "DJ TCHIANDO",
      genre: "Électronique",
      streams: "78M+",
      platform: "Deezer",
      image: "../images/djtchiando.jpeg",
      status: "top",
      growth: "+180%",
      social: { instagram: "2.1M", spotify: "950K" },
      spotifyUrl: "#",
      appleMusicUrl: "#"
    },
    {
      id: 4,
      name: "PLAY SLEK",
      genre: "R&B/Rap",
      streams: "33M+",
      platform: "YouTube Music",
      image: "../images/playslek.jpeg",
      status: "rising",
      growth: "+210%",
      social: { instagram: "1.5M", tiktok: "1.1M" },
      spotifyUrl: "#",
      appleMusicUrl: "#"
    },
    {
      id: 5,
      name: "GERJACK",
      genre: "Hip-Hop",
      streams: "62M+",
      platform: "TikTok",
      image: "../images/gerjack.jpeg",
      status: "established",
      growth: "+75%",
      social: { instagram: "3.2M", tiktok: "4.5M" },
      spotifyUrl: "#",
      appleMusicUrl: "#"
    },
    {
      id: 6,
      name: "DAPAMS",
      genre: "Jazz Moderne",
      streams: "18M+",
      platform: "Spotify",
      image: "../images/dapams.jpeg",
      status: "rising",
      growth: "+150%",
      social: { instagram: "680K", youtube: "320K" },
      spotifyUrl: "#",
      appleMusicUrl: "#"
    }
  ];

  // Plateformes étendues
  const platforms = [
    { name: "Spotify", icon: <FaSpotify />, color: "#1DB954", users: "456M", url: "#" },
    { name: "Apple Music", icon: <FaApple />, color: "#FA243C", users: "88M", url: "#" },
    { name: "Deezer", icon: <FaDeezer />, color: "#00C7F2", users: "16M", url: "#" },
    { name: "YouTube Music", icon: <FaYoutube />, color: "#FF0000", users: "80M", url: "#" },
    { name: "TikTok Music", icon: <FaTiktok />, color: "#000000", users: "1B+", url: "#" },
    { name: "SoundCloud", icon: <FaSoundcloud />, color: "#FF3300", users: "76M", url: "#" },
    { name: "Amazon Music", icon: <FaAmazon />, color: "#FF9900", users: "55M", url: "#" },
    { name: "Twitch Music", icon: <FaTwitch />, color: "#9146FF", users: "140M", url: "#" }
  ];

  // Témoignages
  const testimonials = [
    {
      id: 1,
      name: "Le Sommet",
      role: "Artiste Rappeur",
      content: "StreamDistrib a transformé ma carrière. En 6 mois, mes streams ont augmenté de 450% !",
      image: "../images/silf.jpeg",
      growth: "+450%"
    },
    {
      id: 2,
      name: "ZRZ",
      role: "Producteur Afrobeat",
      content: "La gestion des droits d'auteur était un cauchemar. Maintenant, tout est automatisé et transparent.",
      image: "../images/moi.jpeg",
      growth: "+300%"
    },
    {
      id: 3,
      name: "Chinois",
      role: "DJ Électronique",
      content: "Leurs stratégies de promotion sur TikTok ont fait exploser ma visibilité. Incroyable !",
       image: "../images/anis.jpeg",
       growth: "+600%"
    }
  ];

  // Avantages
  const benefits = [
    {
      icon: <FiTrendingUp />,
      title: "Augmentation des Streams",
      description: "Stratégies prouvées pour booster vos streams de +200% en moyenne",
      color: "#8B5CF6",
      action: () => alert("Découvrez nos stratégies de croissance")
    },
    {
      icon: <FiDollarSign />,
      title: "Revenus Maximisés",
      description: "Optimisation des royalties sur toutes les plateformes",
      color: "#10B981",
      action: () => alert("Maximisez vos revenus maintenant")
    },
    {
      icon: <FiGlobe />,
      title: "Distribution Mondiale",
      description: "Présence sur 150+ plateformes dans 180 pays",
      color: "#3B82F6",
      action: () => alert("Distribution mondiale instantanée")
    },
    {
      icon: <FiBarChart2 />,
      title: "Analyses Détaillées",
      description: "Dashboard en temps réel avec insights actionnables",
      color: "#EF4444",
      action: () => alert("Accédez à vos analyses détaillées")
    },
    {
      icon: <FiClock />,
      title: "Publication Rapide",
      description: "Distribution en 24-48h sur toutes les plateformes",
      color: "#F59E0B",
      action: () => alert("Publiez votre musique rapidement")
    },
    {
      icon: <FiShield />,
      title: "Protection des Droits",
      description: "Surveillance anti-piratage et protection des copyrights",
      color: "#06B6D4",
      action: () => alert("Protégez vos droits d'auteur")
    }
  ];

  // Étapes de collaboration
  const steps = [
    {
      number: "01",
      title: "Audit Gratuit",
      description: "Analyse complète de votre présence actuelle",
      action: handleAuditClick
    },
    {
      number: "02",
      title: "Stratégie Personnalisée",
      description: "Plan d'action sur mesure pour vos objectifs",
      action: () => scrollToSection('contact')
    },
    {
      number: "03",
      title: "Distribution Multiplateforme",
      description: "Publication sur toutes les plateformes en 48h",
      action: () => alert("Découvrez notre processus de distribution")
    },
    {
      number: "04",
      title: "Promotion & Marketing",
      description: "Campagnes ciblées pour maximiser la visibilité",
      action: () => alert("Boostez votre visibilité")
    },
    {
      number: "05",
      title: "Suivi & Optimisation",
      description: "Analyses continues et ajustements en temps réel",
      action: () => alert("Suivez vos performances")
    }
  ];

  // Filtrage des artistes
  const filteredArtists = activeFilter === 'all' 
    ? artists 
    : artists.filter(artist => artist.status === activeFilter);

  // Gestion du formulaire
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setContactData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulation d'envoi
    setTimeout(() => {
      setFormSubmitted(true);
      setContactData({
        name: '',
        email: '',
        phone: '',
        artistName: '',
        genre: '',
        message: ''
      });
      // Réinitialiser après 5 secondes
      setTimeout(() => setFormSubmitted(false), 5000);
    }, 1000);
  };

  // Navigation mobile
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  return (
    <div className="app">
      {/* Navigation Premium */}
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <div className="nav-content">
            <button 
              className="logo-button"
              onClick={() => scrollToSection('home')}
              aria-label="Retour à l'accueil"
            >
              <div className="logo">
                <FiPlay className="logo-icon" />
                <span className="logo-text">StreamDistrib<span className="logo-pro">PRO</span></span>
              </div>
            </button>
            
            <div className="nav-links">
              <button 
                className="nav-link"
                onClick={() => scrollToSection('home')}
              >
                <FiPlay /> Accueil
              </button>
              <button 
                className="nav-link"
                onClick={() => scrollToSection('artists')}
              >
                <FiUsers /> Artistes
              </button>
              <button 
                className="nav-link"
                onClick={() => scrollToSection('services')}
              >
                <FiMusic /> Services
              </button>
              <button 
                className="nav-link"
                onClick={() => scrollToSection('ceos')}
              >
                <MdOutlineGroup /> Équipe
              </button>
              <button 
                className="nav-link"
                onClick={() => scrollToSection('testimonials')}
              >
                <FiStar /> Témoignages
              </button>
              <button 
                className="nav-link highlight"
                onClick={handleAuditClick}
              >
                <FiMessageSquare /> Devis Gratuit
              </button>
            </div>

            <div className="nav-cta">
              <button 
                className="phone-button"
                onClick={() => window.location.href = 'tel:+22870347583'}
                aria-label="Appeler"
              >
                <FiPhone /> 
              </button>
              <button 
                className="cta-button nav-cta-btn"
                onClick={handleContactClick}
              >
                <FiHeadphones /> Contact Rapide
              </button>
            </div>

            <button 
              className="menu-button"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label={isMenuOpen ? "Fermer le menu" : "Ouvrir le menu"}
            >
              {isMenuOpen ? <FiX /> : <FiMenu />}
            </button>
          </div>

          {/* Menu Mobile Overlay */}
          {isMenuOpen && (
            <div className="mobile-menu-overlay">
              <div className="mobile-menu">
                <button 
                  className="mobile-nav-link"
                  onClick={() => scrollToSection('home')}
                >
                  <FiPlay /> Accueil
                </button>
                <button 
                  className="mobile-nav-link"
                  onClick={() => scrollToSection('artists')}
                >
                  <FiUsers /> Artistes
                </button>
                <button 
                  className="mobile-nav-link"
                  onClick={() => scrollToSection('services')}
                >
                  <FiMusic /> Services
                </button>
                <button 
                  className="mobile-nav-link"
                  onClick={() => scrollToSection('ceos')}
                >
                  <MdOutlineGroup /> Équipe
                </button>
                <button 
                  className="mobile-nav-link"
                  onClick={() => scrollToSection('testimonials')}
                >
                  <FiStar /> Témoignages
                </button>
                <button 
                  className="mobile-nav-link highlight"
                  onClick={handleAuditClick}
                >
                  <FiMessageSquare /> Devis Gratuit
                </button>
                <button 
                  className="mobile-phone-button"
                  onClick={() => window.location.href = 'tel:+22870347583'}
                >
                  <FiPhone /> Appeler
                </button>
                <button 
                  className="mobile-contact-button"
                  onClick={handleContactClick}
                >
                  <FiMail /> Nous contacter
                </button>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section Ultra-Moderne */}
      <section id="home" className="hero-section">
        <div className="hero-background">
          <div className="particles"></div>
          <div className="gradient-orbs">
            <div className="orb orb-1"></div>
            <div className="orb orb-2"></div>
            <div className="orb orb-3"></div>
          </div>
        </div>
        
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <div className="hero-badge">
                <FaCrown /> AGENCE #1 EN DISTRIBUTION DIGITALE
              </div>
              
              <h1 className="hero-title">
                <span className="title-line">Votre musique</span>
                <span className="title-gradient">sur toutes les plateformes</span>
                <span className="title-line">avec des résultats garantis</span>
              </h1>
              
              <p className="hero-description">
                Distribution stratégique sur 150+ plateformes, marketing viral et maximisation 
                des revenus. <strong>Augmentation moyenne de +200% des streams</strong> en quelques mois.
              </p>

              {/* Stats en temps réel */}
              <div className="hero-stats">
                <div className="stat-item">
                  <div className="stat-number">{stats.artists}+</div>
                  <div className="stat-label">Artistes Satisfaits </div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">{stats.streams}M+</div>
                  <div className="stat-label">Streams Mensuels</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">{stats.countries}+</div>
                  <div className="stat-label">Pays Couverts</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">{stats.revenue}MillionsFCFA+</div>
                  <div className="stat-label">Revenus Générés</div>
                </div>
              </div>

              <div className="hero-actions">
                <button 
                  className="primary-button hero-cta"
                  onClick={handleAuditClick}
                >
                  <FaRocket /> Commencer Gratuitement
                  <span className="cta-sub">Audit 100% gratuit - Sans engagement</span>
                </button>
                
                <button 
                  className="secondary-button"
                  onClick={handleDemoClick}
                >
                  <FiPlay /> Voir la Démo
                </button>

                <button 
                  className="music-player-button"
                  onClick={handlePlayMusic}
                  aria-label={isPlaying ? "Pause" : "Écouter un extrait"}
                >
                  {isPlaying ? <FaPauseCircle /> : <FaPlayCircle />}
                  {isPlaying ? "Pause" : "Écouter"}
                </button>
              </div>

              {/* Badges de confiance */}
              <div className="trust-badges">
                <div className="badge">
                  <MdOutlineVerified /> Garantie Résultats
                </div>
                <div className="badge">
                  <FiShield /> Contrat Flexible
                </div>
                <div className="badge">
                  <FiAward /> Service Premium
                </div>
              </div>
            </div>

            {/* Visual interactif */}
            <div className="hero-visual">
              <div className="visual-container">
                <div className="platform-wheel">
                  {platforms.map((platform, index) => (
                    <button
                      key={index}
                      className="platform-wheel-item"
                      style={{ '--angle': `${index * 45}deg` }}
                      onClick={() => handlePlatformClick(platform.name)}
                      aria-label={`Distribution sur ${platform.name}`}
                    >
                      <div className="wheel-icon" style={{ color: platform.color }}>
                        {platform.icon}
                      </div>
                      <span>{platform.name}</span>
                    </button>
                  ))}
                </div>
                
                <div className="success-card">
                  <div className="success-header">
                    <FaFire className="fire-icon" />
                    <h3>Success Story du Mois</h3>
                  </div>
                  <div className="success-content">
                    <button 
                      className="artist-success"
                      onClick={() => handleArtistClick("DJ Nova")}
                    >
                      <img src={artists[2].image} alt="LS Le Sommet" />
                      <div>
                        <h4>LS Le Sommet</h4>
                        <p>+180% de streams en 30 jours</p>
                      </div>
                    </button>
                    <div className="success-stats">
                      <div className="stat">
                        <FiTrendingUp />
                        <span>78M → 140M</span>
                      </div>
                      <div className="stat">
                        <FiDollarSign />
                        <span>+45KFCFA de revenus</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section Plateformes */}
      <section className="platforms-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">
              Distribution sur <span className="highlight-text">150+ plateformes</span> mondiales
            </h2>
            <p className="section-description">
              Votre musique disponible partout où vos fans écoutent
            </p>
          </div>
          
          <div className="platforms-grid">
            {platforms.map((platform, index) => (
              <button
                key={index}
                className="platform-card"
                onClick={() => handlePlatformClick(platform.name)}
                aria-label={`Distribuer sur ${platform.name}`}
              >
                <div className="platform-icon" style={{ color: platform.color }}>
                  {platform.icon}
                </div>
                <h3>{platform.name}</h3>
                <p className="platform-users">{platform.users} utilisateurs</p>
                <div className="platform-status">
                  <div className="status-dot active"></div>
                  <span>Actif</span>
                </div>
              </button>
            ))}
          </div>
          
          <div className="distribution-metrics">
            <div className="metric">
              <div className="metric-value">24-72h</div>
              <div className="metric-label">Temps de distribution</div>
            </div>
            <div className="metric">
              <div className="metric-value">100%</div>
              <div className="metric-label">Couverture mondiale</div>
            </div>
            <div className="metric">
              <div className="metric-value">0%</div>
              <div className="metric-label">Frais cachés</div>
            </div>
          </div>

          <div className="platforms-cta">
            <button 
              className="cta-button large"
              onClick={handleAuditClick}
            >
              <FiExternalLink /> Vérifier la disponibilité sur toutes les plateformes
            </button>
          </div>
        </div>
      </section>

      {/* Section Avantages */}
      <section id="services" className="benefits-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">
              Pourquoi choisir <span className="highlight-text">StreamDistrib PRO</span> ?
            </h2>
            <p className="section-description">
              Une approche premium qui fait la différence
            </p>
          </div>
          
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <button
                key={index}
                className="benefit-card"
                style={{ '--delay': `${index * 100}ms` }}
                onClick={benefit.action}
                aria-label={`En savoir plus sur ${benefit.title}`}
              >
                <div className="benefit-icon" style={{ background: benefit.color }}>
                  {benefit.icon}
                </div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
                <div className="benefit-arrow">
                  <FiChevronRight />
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Section Processus */}
      <section className="process-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Votre succès en 5 étapes simples</h2>
            <p className="section-description">
              Un processus transparent et efficace pour maximiser votre potentiel
            </p>
          </div>
          
          <div className="process-steps">
            {steps.map((step, index) => (
              <button
                key={index}
                className="process-step"
                onClick={step.action}
                aria-label={`Étape ${step.number}: ${step.title}`}
              >
                <div className="step-number">{step.number}</div>
                <div className="step-content">
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
                {index < steps.length - 1 && (
                  <div className="step-connector">
                    <FiChevronRight />
                  </div>
                )}
              </button>
            ))}
          </div>

          <div className="process-cta">
            <button 
              className="primary-button large"
              onClick={handleAuditClick}
            >
              <FaArrowRight /> Commencer avec l'étape 1
            </button>
          </div>
        </div>
      </section>

      {/* Section Artistes */}
      <section id="artists" className="artists-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">
              Nos <span className="highlight-text">artistes</span> à succès
            </h2>
            <p className="section-description">
              Découvrez les talents que nous accompagnons vers l'excellence
            </p>
          </div>
          
          <div className="filter-buttons">
            <button 
              className={`filter-button ${activeFilter === 'all' ? 'active' : ''}`}
              onClick={() => setActiveFilter('all')}
              aria-label="Voir tous les artistes"
            >
              <FiUsers /> Tous les artistes
            </button>
            <button 
              className={`filter-button ${activeFilter === 'rising' ? 'active' : ''}`}
              onClick={() => setActiveFilter('rising')}
              aria-label="Voir les étoiles montantes"
            >
              <FaFire /> Étoiles montantes
            </button>
            <button 
              className={`filter-button ${activeFilter === 'established' ? 'active' : ''}`}
              onClick={() => setActiveFilter('established')}
              aria-label="Voir les artistes établis"
            >
              <MdOutlineVerified /> Établis
            </button>
            <button 
              className={`filter-button ${activeFilter === 'top' ? 'active' : ''}`}
              onClick={() => setActiveFilter('top')}
              aria-label="Voir les têtes d'affiche"
            >
              <FaCrown /> Têtes d'affiche
            </button>
          </div>
          
          <div className="artists-grid">
            {filteredArtists.map((artist, index) => (
              <div key={artist.id} className="artist-card" style={{ '--delay': `${index * 100}ms` }}>
                <div className="artist-image-container">
                  <img src={artist.image} alt={artist.name} className="artist-image" />
                  <div className="artist-overlay">
                    <button 
                      className="play-button"
                      onClick={() => handleArtistClick(artist.name)}
                      aria-label={`Écouter ${artist.name}`}
                    >
                      <FiPlay />
                    </button>
                    <div className="social-stats">
                      <button 
                        className="social-stat"
                        onClick={() => handleSocialClick('Instagram')}
                        aria-label={`Instagram de ${artist.name}`}
                      >
                        <FiInstagram /> {artist.social.instagram}
                      </button>
                      {artist.social.tiktok && (
                        <button 
                          className="social-stat"
                          onClick={() => handleSocialClick('TikTok')}
                          aria-label={`TikTok de ${artist.name}`}
                        >
                          <FaTiktok /> {artist.social.tiktok}
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="growth-badge" style={{ background: artist.status === 'top' ? '#F59E0B' : '#8B5CF6' }}>
                    <FiTrendingUp /> {artist.growth}
                  </div>
                </div>
                
                <div className="artist-info">
                  <div className="artist-header">
                    <div>
                      <h3 className="artist-name">{artist.name}</h3>
                      <div className="artist-tags">
                        <span className="genre-tag">{artist.genre}</span>
                        <button 
                          className="platform-tag"
                          onClick={() => handlePlatformClick(artist.platform)}
                          aria-label={`Écouter sur ${artist.platform}`}
                        >
                          {artist.platform === 'Spotify' && <FaSpotify />}
                          {artist.platform === 'Apple Music' && <FaApple />}
                          {artist.platform === 'Deezer' && <FaDeezer />}
                          {artist.platform === 'YouTube Music' && <FaYoutube />}
                          {artist.platform === 'TikTok' && <FaTiktok />}
                          {artist.platform}
                        </button>
                      </div>
                    </div>
                    <div className="streams-count">
                      <FiHeadphones />
                      <span>{artist.streams}</span>
                    </div>
                  </div>
                  
                  <div className="artist-metrics">
                    <div className="metric">
                      <FiTrendingUp />
                      <span>Croissance: {artist.growth}</span>
                    </div>
                    <div className="metric">
                      <FiCalendar />
                      <span>Depuis 6 mois</span>
                    </div>
                  </div>
                  
                  <div className="artist-actions">
                    <button 
                      className="action-button"
                      onClick={() => handleArtistClick(artist.name)}
                    >
                      <FiPlay /> Écouter
                    </button>
                    <button 
                      className="action-button outline"
                      onClick={() => alert(`Partager ${artist.name}`)}
                    >
                      <FiShare2 /> Partager
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="artists-cta">
            <button 
              className="primary-button large"
              onClick={() => alert("Voir tous les artistes")}
            >
              <FiExternalLink /> Voir tous nos artistes
            </button>
          </div>
        </div>
      </section>

      {/* Section CEO */}
      <section id="ceos" className="ceo-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">
              Rencontrez nos <span className="highlight-text">experts</span>
            </h2>
            <p className="section-description">
              3 CEO, 1 vision : votre succès
            </p>
          </div>
          
          <div className="ceo-grid">
            {ceos.map(ceo => (
              <div key={ceo.id} className="ceo-card">
                <div className="ceo-image-container">
                  <img src={ceo.image} alt={ceo.name} className="ceo-image" />
                  <div className="ceo-stats">
                    <div className="ceo-stat">
                      <FiStar />
                      <span>{ceo.stats}</span>
                    </div>
                  </div>
                </div>
                
                <div className="ceo-info">
                  <div className="ceo-badge">
                    <FaCrown /> CEO
                  </div>
                  <h3 className="ceo-name">{ceo.name}</h3>
                  <p className="ceo-role">{ceo.role}</p>
                  <p className="ceo-bio">{ceo.bio}</p>
                  
                  <div className="ceo-contact">
                    <button 
                      className="contact-link"
                      onClick={() => window.location.href = `mailto:${ceo.email}`}
                    >
                      <FiMail /> Prendre RDV
                    </button>
                    <div className="ceo-social">
                      <button 
                        className="social-icon"
                        onClick={() => handleSocialClick('LinkedIn')}
                        aria-label={`LinkedIn de ${ceo.name}`}
                      >
                        <FiLinkedin />
                      </button>
                      <button 
                        className="social-icon"
                        onClick={() => handleSocialClick('Twitter')}
                        aria-label={`Twitter de ${ceo.name}`}
                      >
                        <FiTwitter />
                      </button>
                      <button 
                        className="social-icon"
                        onClick={() => handleSocialClick('Instagram')}
                        aria-label={`Instagram de ${ceo.name}`}
                      >
                        <FiInstagram />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="ceo-cta">
            <button 
              className="secondary-button large"
              onClick={() => window.location.href = 'mailto:contact@streamdistrib.pro'}
            >
              <MdOutlineEmail /> Contacter l'équipe de direction
            </button>
          </div>
        </div>
      </section>

      {/* Section Témoignages */}
      <section id="testimonials" className="testimonials-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">
              Ils nous font <span className="highlight-text">confiance</span>
            </h2>
            <p className="section-description">
              Découvrez les retours d'expérience de nos artistes
            </p>
          </div>
          
          <div className="testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <button
                key={testimonial.id}
                className="testimonial-card"
                onClick={() => alert(`Lire le témoignage complet de ${testimonial.name}`)}
                aria-label={`Témoignage de ${testimonial.name}`}
              >
                <div className="testimonial-header">
                  <img src={testimonial.image} alt={testimonial.name} />
                  <div>
                    <h4>{testimonial.name}</h4>
                    <p className="testimonial-role">{testimonial.role}</p>
                  </div>
                  <div className="growth-badge testimonial-growth">
                    <FiTrendingUp /> {testimonial.growth}
                  </div>
                </div>
                
                <p className="testimonial-content">"{testimonial.content}"</p>
                
                <div className="testimonial-footer">
                  <div className="stars">
                    {[...Array(5)].map((_, i) => (
                      <FiStar key={i} className="star-icon" />
                    ))}
                  </div>
                  <span className="testimonial-date">Il y a 1 mois</span>
                </div>
              </button>
            ))}
          </div>

          <div className="testimonials-cta">
            <button 
              className="primary-button large"
              onClick={() => alert("Voir tous les témoignages")}
            >
              <FiExternalLink /> Lire tous les témoignages
            </button>
          </div>
        </div>
      </section>

      {/* Section Contact Premium */}
      <section id="contact" className="contact-section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2 className="section-title">
                Prêt à <span className="highlight-text">exploser</span> vos streams ?
              </h2>
              
              <div className="contact-features">
                <div className="feature">
                  <FiCheckCircle />
                  <div>
                    <h4>Audit Gratuit</h4>
                    <p>Analyse complète de votre potentiel</p>
                  </div>
                </div>
                <div className="feature">
                  <FiCheckCircle />
                  <div>
                    <h4>Stratégie Personnalisée</h4>
                    <p>Plan d'action sur mesure</p>
                  </div>
                </div>
                <div className="feature">
                  <FiCheckCircle />
                  <div>
                    <h4>Suivi Expert</h4>
                    <p>Accompagnement dédié 7j/7</p>
                  </div>
                </div>
              </div>
              
              <div className="contact-methods">
                <button 
                  className="method"
                  onClick={() => window.location.href = 'tel:+22870347583'}
                >
                  <MdOutlinePhone />
                  <div>
                    <h4>Téléphone</h4>
                    <p>+228 70 34 75 83</p>
                  </div>
                </button>
                <button 
                  className="method"
                  onClick={() => window.location.href = 'mailto:contact@gmail.com'}
                >
                  <MdOutlineEmail />
                  <div>
                    <h4>Email</h4>
                    <p>ontact@gmail.com</p>
                  </div>
                </button>
                <button 
                  className="method"
                  onClick={() => alert("Ouvrir la localisation")}
                >
                  <MdOutlineLocationOn />
                  <div>
                    <h4>Bureaux</h4>
                    <p>Lomé, Agoè, Togo</p>
                  </div>
                </button>
              </div>
              
              <div className="guarantee-card">
                <FiShield />
                <div>
                  <h4>Garantie Satisfaction</h4>
                  <p>30 jours d'essai sans engagement</p>
                </div>
              </div>
            </div>
            
            <div className="contact-form-container">
              {formSubmitted ? (
                <div className="success-message">
                  <FiCheckCircle className="success-icon" />
                  <h3>Demande envoyée avec succès !</h3>
                  <p>Notre équipe vous contactera dans les 24 heures pour votre audit gratuit.</p>
                  <button 
                    className="primary-button"
                    onClick={() => setFormSubmitted(false)}
                  >
                    Nouvelle demande
                  </button>
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-header">
                    <h3>Demandez votre audit gratuit</h3>
                    <p>Remplissez le formulaire et recevez votre stratégie personnalisée</p>
                  </div>
                  
                  <div className="form-grid">
                    <div className="form-group">
                      <label>Votre nom *</label>
                      <input
                        type="text"
                        name="name"
                        value={contactData.name}
                        onChange={handleInputChange}
                        required
                        placeholder="John Doe"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label>Email *</label>
                      <input
                        type="email"
                        name="email"
                        value={contactData.email}
                        onChange={handleInputChange}
                        required
                        placeholder="john@example.com"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label>Téléphone</label>
                      <input
                        type="tel"
                        name="phone"
                        value={contactData.phone}
                        onChange={handleInputChange}
                        placeholder="+22870347583"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label>Nom d'artiste</label>
                      <input
                        type="text"
                        name="artistName"
                        value={contactData.artistName}
                        onChange={handleInputChange}
                        placeholder="Votre nom d'artiste"
                      />
                    </div>
                    
                    <div className="form-group full-width">
                      <label>Genre musical</label>
                      <select
                        name="genre"
                        value={contactData.genre}
                        onChange={handleInputChange}
                      >
                        <option value="">Sélectionnez un genre</option>
                        <option value="pop">Pop</option>
                        <option value="hiphop">Hip-Hop</option>
                        <option value="rock">Rock</option>
                        <option value="electronic">Électronique</option>
                        <option value="rnb">R&B</option>
                        <option value="jazz">Jazz</option>
                        <option value="other">Autre</option>
                      </select>
                    </div>
                    
                    <div className="form-group full-width">
                      <label>Votre message</label>
                      <textarea
                        name="message"
                        value={contactData.message}
                        onChange={handleInputChange}
                        rows="4"
                        placeholder="Décrivez vos objectifs et vos attentes..."
                      />
                    </div>
                  </div>
                  
                  <button type="submit" className="submit-button">
                    <FiSend /> Recevoir mon audit gratuit
                  </button>
                  
                  <p className="form-note">
                    * Notre équipe vous contactera dans les 24h pour planifier votre consultation gratuite.
                  </p>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Footer Premium */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-main">
              <button 
                className="footer-logo"
                onClick={() => scrollToSection('home')}
                aria-label="Retour à l'accueil"
              >
                <FiPlay className="logo-icon" />
                <div>
                  <h3>StreamDistrib<span className="logo-pro">PRO</span></h3>
                  <p>Distribution digitale premium pour artistes ambitieux</p>
                </div>
              </button>
              
              <div className="footer-social">
                <button 
                  className="social-link"
                  onClick={() => handleSocialClick('Instagram')}
                  aria-label="Instagram"
                >
                  <FiInstagram />
                </button>
                <button 
                  className="social-link"
                  onClick={() => handleSocialClick('Twitter')}
                  aria-label="Twitter"
                >
                  <FiTwitter />
                </button>
                <button 
                  className="social-link"
                  onClick={() => handleSocialClick('LinkedIn')}
                  aria-label="LinkedIn"
                >
                  <FiLinkedin />
                </button>
                <button 
                  className="social-link"
                  onClick={() => handleSocialClick('TikTok')}
                  aria-label="TikTok"
                >
                  <FaTiktok />
                </button>
                <button 
                  className="social-link"
                  onClick={() => handleSocialClick('YouTube')}
                  aria-label="YouTube"
                >
                  <FaYoutube />
                </button>
                <button 
                  className="social-link"
                  onClick={() => handleSocialClick('Spotify')}
                  aria-label="Spotify"
                >
                  <FaSpotify />
                </button>
              </div>
            </div>
            
            <div className="footer-links">
              <div className="link-group">
                <h4>Services</h4>
                <button onClick={() => alert("Distribution numérique")}>Distribution numérique</button>
                <button onClick={() => alert("Marketing musical")}>Marketing musical</button>
                <button onClick={() => alert("Gestion des droits")}>Gestion des droits</button>
                <button onClick={() => alert("Promotion sur réseaux")}>Promotion sur réseaux</button>
              </div>
              
              <div className="link-group">
                <h4>Ressources</h4>
                <button onClick={() => alert("Blog")}>Blog</button>
                <button onClick={() => alert("Tutoriels")}>Tutoriels</button>
                <button onClick={() => alert("Case studies")}>Case studies</button>
                <button onClick={() => alert("FAQ")}>FAQ</button>
              </div>
              
              <div className="link-group">
                <h4>Entreprise</h4>
                <button onClick={() => scrollToSection('ceos')}>À propos</button>
                <button onClick={() => alert("Carrières")}>Carrières</button>
                <button onClick={() => alert("Presse")}>Presse</button>
                <button onClick={handleContactClick}>Contact</button>
              </div>
              
              <div className="link-group">
                <h4>Légal</h4>
                <button onClick={() => alert("Mentions légales")}>Mentions légales</button>
                <button onClick={() => alert("CGU")}>CGU</button>
                <button onClick={() => alert("Confidentialité")}>Confidentialité</button>
                <button onClick={() => alert("Cookies")}>Cookies</button>
              </div>
            </div>
          </div>
          
          <div className="footer-bottom">
            <p>© 2024 StreamDistrib PRO. Tous droits réservés. | Distribution digitale premium</p>
            <div className="payment-methods">
              <span>Méthodes de paiement:</span>
              <div className="payment-icons">
                <button onClick={() => alert("Carte bancaire")} aria-label="Carte bancaire"><FontAwesomeIcon icon={faCreditCard} /></button>
                <button onClick={() => alert("Mobile")} aria-label="Paiement mobile"><FontAwesomeIcon icon={faMobileAlt} /></button>
                <button onClick={() => alert("Virement")} aria-label="Virement bancaire"><FontAwesomeIcon icon={faUniversity} /></button>
                <button onClick={() => alert("Crypto")} aria-label="Cryptomonnaie"></button>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* CTA Flottant */}
      <div className="floating-cta">
        <button 
          className="floating-button whatsapp"
          onClick={() => window.open('https://wa.me/+22870347583', '_blank')}
          aria-label="Contact WhatsApp"
        >
          <FaWhatsapp /> WhatsApp
        </button>
        <button 
          className="floating-button phone"
          onClick={() => window.location.href = 'tel:+22870347583'}
          aria-label="Appeler"
        >
          <FiPhone /> Appeler
        </button>
        <button 
          className="floating-button main-cta"
          onClick={handleAuditClick}
          aria-label="Demander un devis gratuit"
        >
          <FaRocket /> Devis Gratuit
        </button>
      </div>

      {/* Audio pour la démo */}
      <audio ref={audioRef} src="/demo-music.mp3" preload="metadata" />
    </div>
  );
};

export default App;